import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface SubmitCandidateFeedbackPayload {
  rating: number;
  feedback: string;
}

interface SubmitCandidateFeedbackResponse {
  message: string;
  data: {
    id: number;
    assessment_response: number;
    rating: number;
    feedback: string;
  };
}

export const useSubmitCandidateFeedback = (assessmentResponseId: string) => {
  const { openToast } = useToast();

  const mutation = useMutation({
    mutationFn: async (payload: SubmitCandidateFeedbackPayload) => {
      const response = await apiClient.post<SubmitCandidateFeedbackResponse>(
        `/candidate/assessment-responses/${assessmentResponseId}/review/`,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Success',
        text: 'Thank you for your feedback!',
        type: 'success',
        timeOut: 5000,
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.message || 'Failed to submit feedback. Please try again.';
      openToast({
        show: true,
        heading: 'Error',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });

  return {
    submitFeedback: mutation.mutate,
    submitFeedbackAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    data: mutation.data,
    error: mutation.error,
    reset: mutation.reset,
  };
};
